<div class="drawer-item-wrap" [class.disabled]="isSaving" [class.btn-loading]="isActive && isSaving">
    <div class="drawer-item" [class.active]="isActive" (click)="navigatePage()">
        <div class="drawer-item-content">{{ name }}</div>
    </div>
    <div
        dropdown
        #dropdown="bs-dropdown"
        class="btn-group dropdown dropdown-options"
        [class.disabled]="!site?.created_at"
        [class.btn-loading]="page.is_action_pending"
    >
        <button
            dropdownToggle
            type="button"
            class="btn btn-action dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sp-icon icon-ellipsis"></span>
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
            <li class="base-action" (click)="activatePage()" *ngIf="!isPageActive && !isCartPage">
                <a>
                    <span class="sp-icon icon-watch"></span>
                    {{ "publish" | translate }}
                </a>
            </li>
            <li class="base-action" (click)="showPageSettingsModal(page)" [class.disabled]="isNewPage">
                <a>
                    <span class="sp-icon icon-mixer"></span>
                    {{ "settings" | translate }}
                </a>
            </li>
            <li
                class="base-action"
                (click)="copyPage()"
                *ngIf="!isWebChatBotPage"
                [class.disabled]="isNewPage || isCartPage"
            >
                <a>
                    <span class="sp-icon icon-windows"></span>
                    {{ "duplicate" | translate }}
                </a>
            </li>

            <li (click)="disablePage()" *ngIf="isPageActive && !isCartPage && !isWebChatBotPage">
                <a>
                    <span class="sp-icon icon-unwatch color-danger"></span>
                    {{ "unpublish" | translate }}
                </a>
            </li>
            <li
                (click)="deletePage()"
                *ngIf="!isMainPage(page) && !isWebEducationPage && !isPageActive && !isCartPage && !isWebChatBotPage"
            >
                <a>
                    <span class="sp-icon icon-bin color-danger"></span>
                    {{ "delete" | translate }}
                </a>
            </li>
            <li *ngIf="isMainPage(page) && !isPageActive" [tooltip]="'main_page_cannot_be_deleted_tooltip' | translate">
                <a [class.disabled]="isMainPage(page)">
                    <span class="sp-icon icon-bin color-danger"></span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
